import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class PdfConversionApiService {
  private http = inject(HttpClient);
  public PDF_URL = `${environment.apiUrl}/convert/pdf-to-png`;

  convertToPng(pdfFile: any): Observable<string> {
    const formData = new FormData();
    formData.append("file", pdfFile);
    return this.http.post(this.PDF_URL, formData, {
      responseType: "text",
    });
  }
}
